import React, { useEffect, useRef } from 'react';

import styled from "styled-components";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { useTranslation } from 'react-i18next';
import { FaLongArrowAltLeft } from 'react-icons/fa';

import { useHistory } from "react-router-dom";

import dearfanslogo from "../images/dearfanslogo.png";
import picarelogo from "../images/picarelogo.png";
import ibmlogo from "../images/ibmlogo.png";
import moxlogo from "../images/moxlogo.png";
import sclogo from "../images/sclogo.png";

gsap.registerPlugin(ScrollTrigger)

/* Experience emphasis: data → AI → full-stack → cloud → MLOps */
const SKILLS = [
    { key: 'skillDataEng', level: 94, accent: '#b8d4f0' },
    { key: 'skillAi', level: 91, accent: '#f0b8a8' },
    { key: 'skillFullstack', level: 89, accent: '#e8b86d' },
    { key: 'skillCloud', level: 87, accent: '#c4b5fd' },
    { key: 'skillMlops', level: 85, accent: '#9fd4b0' },
];

const AboutMePageStyled = styled.div`
    overflow: hidden;
    @media (min-width: 1023px) {
        .containermain{
            display: flex;
        }
    }
    .aboutmecanvas {
        min-width: 100vw;
        min-height: 100vh;
        background-color: var(--backgrounda);
        position: relative;
        padding-top: var(--marginhalf);
        padding-left: var(--marginborder);
        padding-right: var(--marginborder);
        z-index: 0;
        box-sizing: border-box;
    }
    .containerleft{
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        opacity: 1;
        @media (min-width: 1023px) {
            padding-top: var(--marginborder);
            padding-bottom: var(--marginhalf);
            padding-left: var(--marginhalf);
            padding-right: var(--marginhalf);
            font-size: var(--fontsizexl);
        }
    }
    .containerright{
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        min-width: 20vw;
        padding-bottom: var(--marginborder);
        @media (min-width: 1023px) {
            padding-top: var(--marginborder);
            padding-bottom: var(--marginhalf);
            padding-left: var(--marginhalf);
            padding-right: var(--marginhalf);
            font-size: var(--fontsizexl);
        }
    }
    .containerskill {
        opacity: 1;
    }
    .skills-panel {
        margin-bottom: 2vh;
    }
    .skills-section-label {
        font-size: var(--fontsizecontentc);
        font-weight: 700;
        letter-spacing: 0.2em;
        text-transform: uppercase;
        color: var(--color-accent);
        margin-bottom: 0.8vh;
    }
    .skills-tagline {
        font-size: var(--fontsizecontentc);
        color: rgba(247, 249, 252, 0.85);
        margin: 0 0 2.5vh;
        line-height: 1.5;
        max-width: 36ch;
    }
    .skill-row {
        margin-bottom: 2.2vh;
        opacity: 0;
        transform: translateX(16px);
    }
    .skill-head {
        display: flex;
        justify-content: space-between;
        align-items: baseline;
        gap: 1rem;
        margin-bottom: 0.6vh;
    }
    .skill-name {
        font-size: var(--fontsizecontentb);
        font-weight: 600;
        color: var(--texta);
    }
    .skill-pct {
        font-size: var(--fontsizecontentc);
        font-weight: 700;
        color: var(--color-accent);
        font-variant-numeric: tabular-nums;
        min-width: 2.5em;
        text-align: right;
    }
    .skill-track {
        height: 0.65vh;
        min-height: 5px;
        border-radius: 999px;
        background: rgba(247, 249, 252, 0.15);
        overflow: hidden;
        position: relative;
    }
    .skill-fill {
        height: 100%;
        width: 0;
        border-radius: inherit;
        position: relative;
        background: linear-gradient(
            90deg,
            var(--skill-accent, var(--color-accent)) 0%,
            rgba(247, 249, 252, 0.95) 100%
        );
        box-shadow: 0 0 12px rgba(232, 184, 109, 0.35);
        &::after {
            content: '';
            position: absolute;
            inset: 0;
            background: linear-gradient(
                105deg,
                transparent 0%,
                rgba(255, 255, 255, 0.45) 45%,
                transparent 90%
            );
            transform: translateX(-120%);
            animation: skill-shimmer 2.4s ease-in-out infinite;
        }
    }
    @keyframes skill-shimmer {
        0% {
            transform: translateX(-120%);
        }
        55%,
        100% {
            transform: translateX(220%);
        }
    }
    .skill-tags {
        display: flex;
        flex-wrap: wrap;
        gap: 0.5vh 0.8vh;
        margin-top: 0.8vh;
    }
    .skill-tag {
        font-size: calc(var(--fontsizecontentc) * 0.92);
        color: rgba(247, 249, 252, 0.75);
        padding: 0.25vh 0.8vh;
        border-radius: 999px;
        border: 1px solid rgba(247, 249, 252, 0.2);
        background: rgba(44, 62, 80, 0.25);
    }
    .containerwork{
        opacity: 1;
    }
    .title{
        font-size: var(--fontsizetitlec);
        font-weight: bold;
        position: relative;
        color: var(--texta);
        background-color: transparent;
        top: 0vh;
        left: 0vh;
        flex:1;
    }
    .bio{
        font-size: var(--fontsizecontentc);
        position: relative;
        color: var(--texta);
        background-color: transparent;
        top: 0vh;
        left: 0vh;
        padding-top: 3vh;
        padding-bottom: 3vh;
        flex: 5;
        text-align: justify;
        /* text-align: left; */
    }
    .workexperience{
        font-size: var(--fontsizecontentb);
        font-weight: bold;
        position: relative;
        text-align: center;
        align-items: center;
        background-color: var(--themecolorc);
        color: var(--backgrounda);
        min-width: 13vh;
        min-height: 13vh;
        margin-top: 3vh;
        margin-bottom: 3vh;
        padding: 2vh;
        border-radius: 15px;
        box-shadow: 0 5px 30px var(--bordertext);
    }
    .workexperienceduration{
        font-size: var(--fontsizecontentc);
        font-weight: 300;
        color: var(--backgrounda);
    }
    .dearfanslogo{
        margin: auto;
        margin-bottom: 2vh;
        min-height: var(--fontsizetitlec);
        width: var(--fontsizetitleb);
        background-color: transparent;
        background-position: center;
        background-repeat: no-repeat; 
        background-image: url(${dearfanslogo});
        background-size: 100%;
        box-sizing: border-box;
    }
    .picarelogo{
        margin: auto;
        margin-bottom: 2vh;
        min-height: var(--fontsizetitlec);
        width: var(--fontsizetitleb);
        background-color: transparent;
        background-position: center;
        background-repeat: no-repeat; 
        background-image: url(${picarelogo});
        background-size: 100%;
        box-sizing: border-box;
    }
    .ibmlogo{
        margin: auto;
        margin-bottom: 1vh;
        min-height: var(--fontsizetitlec);
        width: var(--fontsizetitleb);
        background-color: transparent;
        background-position: center;
        background-repeat: no-repeat; 
        background-image: url(${ibmlogo});
        background-size: 100%;
        box-sizing: border-box;
    }
    .moxlogo{
        margin: auto;
        margin-right: 10px;
        margin-bottom: 1vh;
        min-height: var(--fontsizetitlec);
        width: var(--fontsizetitleb);
        background-color: transparent;
        background-position: center;
        background-repeat: no-repeat;
        background-image: url(${moxlogo});
        background-size: 100%;
        box-sizing: border-box;
    }
    .sclogo{
        margin: auto;
        margin-left: 0;
        margin-bottom: 1vh;
        min-height: var(--fontsizetitlec);
        width: var(--fontsizetitleb);
        background-color: transparent;
        background-position: center;
        background-repeat: no-repeat; 
        background-image: url(${sclogo});
        background-size: 100%;
        box-sizing: border-box;
    }
    .arrowback {
        position: fixed;
        top: calc(var(--marginborder) + 1vh);
        left: var(--marginborder);
        z-index: 60;
        font-size: 3vh;
        color: var(--texta);
        width: auto;
        @media (min-width: 1023px) {
            top: calc(var(--marginborder) + 1.5vh);
            left: calc(var(--marginborder) + 2vh);
            font-size: 5vh;
        }
    }
    .sitenamecontainer {
        background-color: transparent;
        color: var(--texta);
        font-size: var(--fontsizeborder);
        font-weight: bold;
        text-align: right;
        position: relative;
        z-index: 5;
        padding: 0;
        padding-bottom: var(--marginhalf);
        margin: auto;
        @media (min-width: 1023px) {
            display: none;
        }
    }
    .sitename{
        background-color: transparent;
        color: var(--texta);
    }
    .side-by-side {
        display: flex;
    }
`;

function AboutMePage() {
    const [t] = useTranslation();
    const history = useHistory();
    const skillsRef = useRef(null);

    useEffect(() => {
        const panel = skillsRef.current;
        if (!panel) return undefined;

        const ctx = gsap.context(() => {
            gsap.to('.skill-row', {
                opacity: 1,
                x: 0,
                duration: 0.55,
                stagger: 0.1,
                ease: 'power2.out',
                scrollTrigger: {
                    trigger: panel,
                    start: 'top 88%',
                    toggleActions: 'play none none reverse',
                },
            });

            panel.querySelectorAll('.skill-fill').forEach((fill, index) => {
                const level = Number(fill.dataset.level) || 0;
                gsap.fromTo(
                    fill,
                    { width: '0%' },
                    {
                        width: `${level}%`,
                        duration: 1.15,
                        delay: 0.15 + index * 0.1,
                        ease: 'power3.out',
                        scrollTrigger: {
                            trigger: panel,
                            start: 'top 88%',
                            toggleActions: 'play none none reverse',
                        },
                    }
                );
            });

            panel.querySelectorAll('.skill-pct').forEach((pct, index) => {
                const target = Number(pct.dataset.target) || 0;
                const counter = { value: 0 };
                gsap.to(counter, {
                    value: target,
                    duration: 1.1,
                    delay: 0.2 + index * 0.1,
                    ease: 'power2.out',
                    scrollTrigger: {
                        trigger: panel,
                        start: 'top 88%',
                        toggleActions: 'play none none reverse',
                    },
                    onUpdate: () => {
                        pct.textContent = `${Math.round(counter.value)}%`;
                    },
                });
            });
        }, panel);

        return () => ctx.revert();
    }, [t]);

    return (
        <AboutMePageStyled>
            <div className="aboutmecanvas" >
                <a href="/" style={{ textDecoration: 'none' }}>
                    <div className="arrowback">
                        <FaLongArrowAltLeft />
                    </div>
                </a>
                <div className="sitenamecontainer">
                    <a href="/" style={{ textDecoration: "none" }}>
                        <div className='sitename'>
                            {t('TopBorder.SiteName')}
                        </div>
                    </a>
                </div>
                <div className="containermain">
                    <div className="containerleft">
                        <div className="title" >
                            {t('AboutMePage.titlea')}<br />{t('AboutMePage.titleb')}
                        </div>
                        <div className="bio">
                            <div dangerouslySetInnerHTML={{ __html: t('AboutMePage.bio') }} />
                            <a onClick={() => { history.push('/contact'); }}>
                                <u>{t('AboutMePage.biohere')}</u>
                            </a>
                            {t('AboutMePage.bio2')}
                        </div>
                    </div>
                    <div className="containerright">
                        <div className="containerskill skills-panel" ref={skillsRef}>
                            <div className="skills-section-label">
                                {t('AboutMePage.skillsSection')}
                            </div>
                            <p className="skills-tagline">{t('AboutMePage.skillsTagline')}</p>
                            {SKILLS.map(({ key, level, accent }) => (
                                <div className="skill-row" key={key}>
                                    <div className="skill-head">
                                        <span className="skill-name">{t(`AboutMePage.${key}`)}</span>
                                        <span className="skill-pct" data-target={level}>0%</span>
                                    </div>
                                    <div className="skill-track">
                                        <div
                                            className="skill-fill"
                                            data-level={level}
                                            style={{ '--skill-accent': accent }}
                                        />
                                    </div>
                                    <div className="skill-tags">
                                        {t(`AboutMePage.${key}Tags`, { returnObjects: true }).map((tag) => (
                                            <span className="skill-tag" key={tag}>{tag}</span>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="containerwork">
                            <div className="workexperience">
                                <div className="side-by-side">
                                    <div className="moxlogo" />
                                    <div className="sclogo" />
                                </div>
                                <div>
                                    {t('AboutMePage.workexperienceda')}
                                </div>
                                <div className='workexperienceduration'>
                                    {t('AboutMePage.workexperiencedc')}
                                </div>
                            </div>
                            <div className="workexperience">
                                <div className="ibmlogo" />
                                <div>
                                    {t('AboutMePage.workexperienceca')}
                                </div>
                                <div>
                                    {t('AboutMePage.workexperiencecb')}
                                </div>
                                <div className='workexperienceduration'>
                                    {t('AboutMePage.workexperiencecc')}
                                </div>
                            </div>
                            {/* <div className="workexperience">
                                <div className="dearfanslogo" />
                                <div>
                                    {t('AboutMePage.workexperienceba')}
                                </div>
                                <div className='workexperienceduration'>
                                    {t('AboutMePage.workexperiencebb')}
                                </div>
                            </div>
                            <div className="workexperience">
                                <div className="picarelogo" />
                                <div>
                                    {t('AboutMePage.workexperienceaa')}
                                </div>
                                <div className='workexperienceduration'>
                                    {t('AboutMePage.workexperienceab')}
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </AboutMePageStyled>
    )
}

export default AboutMePage;